/* eslint-disable no-unused-vars */
export const enum Motif {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  SUCCESS = 'success',
}
